type EventCallback = (...args: any[]) => void;
export class EventEmitter {
    private events: { [key: string]: EventCallback[]; } = {};

    on(event: string, listener: EventCallback) {
        if (!this.events[event]) {
            this.events[event] = [];
        }
        this.events[event].push(listener);
    }

    emit(event: string, ...args: any[]) {
        if (this.events[event]) {
            this.events[event].forEach((listener) => listener(...args));
        }
    }
}
